export type ToolStatus = 'active' | 'coming-soon';

export interface ToolDef {
  name: string;
  status: ToolStatus;
  description: string;
  /** SPA-Pfad unter app.teamity.io (z.B. /inner-team). Für coming-soon irrelevant. */
  entryPath: string;
}

export const TOOLS = {
  'inner-team': {
    name: 'Inneres Team',
    status: 'active',
    description: 'Erkunde deine inneren Stimmen nach Schulz von Thun und lass sie zu Wort kommen.',
    entryPath: '/inner-team',
  },
  'inner-strengths': {
    name: 'InnerStrengths',
    status: 'coming-soon',
    description: 'Stärken und Talente sichtbar machen.',
    entryPath: '/inner-strengths',
  },
  'inner-values': {
    name: 'InnerValues',
    status: 'coming-soon',
    description: 'Die eigenen Wertvorstellungen entdecken.',
    entryPath: '/inner-values',
  },
  'inner-purpose': {
    name: 'InnerPurpose',
    status: 'coming-soon',
    description: 'Erforsche deinen Purpose, dein Why.',
    entryPath: '/inner-purpose',
  },
  'inner-journal': {
    name: 'InnerJournal',
    status: 'coming-soon',
    description: 'Geführtes Tagesjournal mit reflektierenden Fragen.',
    entryPath: '/inner-journal',
  },
} as const satisfies Record<string, ToolDef>;

export type ToolKey = keyof typeof TOOLS;

export const ACTIVE_TOOL_KEYS = (Object.keys(TOOLS) as ToolKey[]).filter(
  (k) => TOOLS[k].status === 'active',
);

export function isToolKey(value: unknown): value is ToolKey {
  return typeof value === 'string' && value in TOOLS;
}
